import { render, staticRenderFns } from "./ColumnResizer.vue?vue&type=template&id=28263a4f&scoped=true"
import script from "./ColumnResizer.vue?vue&type=script&lang=js"
export * from "./ColumnResizer.vue?vue&type=script&lang=js"
import style0 from "./ColumnResizer.vue?vue&type=style&index=0&id=28263a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28263a4f",
  null
  
)

export default component.exports